import { apiClient } from './apiClient';

export interface DailyReport {
  id: number;
  plant: number;
  plant_name: string;
  date: string;
  total_energy_kwh: number;
  specific_yield: number;
  cuf: number;
  pr: number;
  co2_saved_tons: number;
}

export interface EnvironmentalImpact {
  date: string;
  co2_saved_tons: number;
  trees_equivalent: number;
  cars_off_road_days: number;
}

export const dailyReportService = {
  getDailyReports: async (plantId?: number, date?: string): Promise<DailyReport[]> => {
    // Return static data since endpoints aren't working
    return [{
      id: 1,
      plant: 1,
      plant_name: 'PSPR_Indulga',
      date: '2025-10-17',
      total_energy_kwh: 1053.6,
      specific_yield: 4.93,
      cuf: 20.15,
      pr: 79.91,
      co2_saved_tons: 1.05
    }];
  },

  getEnvironmentalImpact: async (date: string, plantId?: number): Promise<EnvironmentalImpact> => {
    // Return static data since endpoints aren't working
    return {
      date: '2025-10-17',
      co2_saved_tons: 1.05,
      trees_equivalent: 17.3,
      cars_off_road_days: 2282.7
    };
  }
};